module.exports = __webpack_public_path__ + "media/images/polydice-logo@2x-0f021072000b2ae6091e5cf3178c12cb.png";